import React from 'react';
import { ReportTableColumnHeader } from 'components/Reports/Report/MastodonReport/ReportTable';
import { useMastodonReport } from 'components/Reports/Report/MastodonReport/MastodonReportContext';

// The title of a two-column label/value table. With the flag on it is one
// column header over both columns, so it heads the labels and the values.
const EducationTableTitle = ({ children }: { children: React.ReactNode }) =>
  useMastodonReport() ? (
    <ReportTableColumnHeader colSpan={2}>
      <b>{children}</b>
    </ReportTableColumnHeader>
  ) : (
    <>
      <td className='column-6'>
        <b>{children}</b>
      </td>
      <td className='column-6' />
    </>
  );

export default EducationTableTitle;
